exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2nNVAptGp6yi4G{color:#5e6c84;font-size:12px;font-weight:500;letter-spacing:.04em;line-height:16px;margin-top:16px;text-transform:uppercase}._3T1fx1UMd-8Lb7{padding:4px 8px 4px 4px;height:40px;display:flex;flex-direction:row;align-items:center;justify-content:flex-start;width:100%;margin:0;background-color:transparent}._3T1fx1UMd-8Lb7:hover{background-color:rgba(9,30,66,.04)}._3T1fx1UMd-8Lb7:active{background-color:#e4f0f6}._2aJCCMSwH-jyc2{flex:1;text-align:left}._1vcWoKq4yr96kI{display:inline-block;margin-right:8px}", ""]);

// exports
exports.locals = {
	"heading": "_2nNVAptGp6yi4G",
	"memberButton": "_3T1fx1UMd-8Lb7",
	"memberName": "_2aJCCMSwH-jyc2",
	"memberAvatar": "_1vcWoKq4yr96kI"
};